import ActiveDot from '@assets/svg/active_dot.svg';
import {colors} from '@styles/colors';
import styled from '@emotion/styled';
import {memo} from 'react';
import {SerializedStyles} from '@emotion/react';

interface ActiveStatusProps {
  className?: string;
  active?: boolean;
  css?: SerializedStyles;
}

const Dot = styled(ActiveDot)`
  fill: ${(props) => (props.active == 1 ? colors.green : colors.red)};
  width: 14px;
  height: 14px;
`;

export const ActiveStatus = ({ className = '', css, active = true }: ActiveStatusProps) => (
  <Dot className={className} css={css} active={+active} />
);

export default memo(ActiveStatus);
